var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-right_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 1h16v16H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-right_svg__a)",
    "data-name": "Scroll Group 5",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(0 -1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4,
    d: "M4.434 16.034a.68.68 0 0 1-.068-.88l.068-.076 5.809-5.844L4.434 3.39a.68.68 0 0 1-.065-.882l.065-.074a.671.671 0 0 1 .877-.066l.073.066 6.289 6.321a.68.68 0 0 1 .061.879l-.065.076-6.285 6.324a.671.671 0 0 1-.95 0Z",
    "data-name": "Path 370"
  }))));
};
export default SvgArrowRight;